import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const AddChildToYearMutation = graphql.persisted(
  "AddChildToYear",
  graphql(`
    mutation AddChildToYear(
      $familyEnrollmentId: ID!
      $firstName: String!
      $lastName: String!
      $dateOfBirth: ISO8601Date
      $gender: GenderEnum
      $gradeLevel: String!
      $status: StudentEnrollmentStatusEnum
      $tuitionOptionKey: String
      $startsOn: ISO8601Date
    ) {
      addChildToYear(input: {
        familyEnrollmentId: $familyEnrollmentId
        firstName: $firstName
        lastName: $lastName
        dateOfBirth: $dateOfBirth
        gender: $gender
        gradeLevel: $gradeLevel
        status: $status
        tuitionOptionKey: $tuitionOptionKey
        startsOn: $startsOn
      }) {
        studentEnrollment { id }
        userErrors { message path }
      }
    }
  `)
);

export { AddChildToYearMutation };

export function useAddChildToYear() {
  return useMutation(AddChildToYearMutation);
}
